import React from 'react'
import PropTypes from 'prop-types'

import { Heading } from 'Components/Blocks/_Legacy'
import { SwiperNarrow, SwiperWide } from 'Components/Blocks/_Legacy/Swipers'
import { Motion, Wrapper } from 'Components/UI'

import { iconCpuGlyph } from 'Assets/_Legacy/CtoPage'

import { SWIPER_KINDS } from 'Constants/Swipers'

import { CTOS } from './data'
import { Container, Content } from './styles'

function YourCtos({ data }) {
  return (
    <Container>
      <Wrapper>
        <Content>
          <Motion>
            <Heading
              fontSizes={{ title: [24, 24, 45], sub: [14, 14, 16] }}
              horizontalAlign={['left', 'left', 'center']}
              mb={[20, 20, 32, 48, 64]}
              tagGlyph={iconCpuGlyph}
              tagText={data?.yourCtosTagText}
              titleText={{
                first: { text: data?.yourCtosTitleRegular, bold: false },
                second: { text: data?.yourCtosTitleBold, bold: true },
              }}
            />
          </Motion>

          <Motion>
            <SwiperWide data={CTOS} kind={SWIPER_KINDS.CTOS} />

            <SwiperNarrow data={CTOS} kind={SWIPER_KINDS.CTOS} />
          </Motion>
        </Content>
      </Wrapper>
    </Container>
  )
}

YourCtos.defaultProps = {
  data: {},
}

YourCtos.propTypes = {
  data: PropTypes.object,
}

export default YourCtos
